export const paths = {
  LANDING: '/',
  SEARCH: '/search/quick/query',
  PREVIEW: '/search/quick/results',
  ADVANCED: '/search/advanced',
  HISTORY_RECENT: '/history/recent',
  HISTORY_SAVED: '/history/saved',
  RESULTS:
    '/results/:context/:databaseId/:resultName/:hitSetKey/list/:searchId/:pageNumber?/:order?/:sort?/:isFromAdvancedSearch?/:fromContext?/:limitOrExclude?',
  HEATMAP:
    '/results/:context/:databaseId/:resultName/:hitSetKey/heatmap/:searchId/index/:index?/isRow/:isRow?/sort/:sort?/ascending/:ascending?/sortedMatrixName/:sortedMatrixName?/fromContext/:fromContext?/limitOrExclude/:limitOrExclude?/origSortedMatrixName/:origSortedMatrixName?',
  ALERTS: '/alerts',
  DNS_MAINTENANCE: '/dns-maintenance',
  REGISTER_BULK: '/bulk',
  REGISTER: '/register',
  FINALIZE_REGISTER: '/finalize-register',
  REGISTER_CONFIRMATION: '/register/user/:regId',
  MAINTENANCE: '/maintenance',
  ERROR: '/error',
  ABOUT_CONTENT: '/about-content',
  DEV: '/dev',
  RS: '/retrosynthesis',
  RS_PROJECTS: '/retrosynthesis/myprojects',
  RS_PROJECT: '/retrosynthesis/myprojects/:projectId',
  RS_PROJECT_TREE: '/retrosynthesis/myprojects/:projectId/:routeId/tree',
  RS_DRAW: '/retrosynthesis/draw',
  PROFILE: '/profile-settings',
  PROFILE_ACCOUNT: '/profile-settings/account',
  PROFILE_PROFILE: '/profile-settings/profile',
  PROFILE_PREFERENCES: '/profile-settings/preferences',
  STRUCTURE_EDITOR: '/structure-editor/:structureUID',
  HOP_INTO: '/hopinto',
  PRIVATE_REGISTER: '/security/register',
  PRIVATE_FINALIZE_REGISTER: '/security/finalize-register',
  // Login-related routes
  LOGOUT: '/logout',
  LOGIN_LIMIT: '/login-limit',
  LOGIN: '/login', // ?action&token
  LOGIN_ORGANIZATION: '/organization',
  LOGIN_INSTITUTION: '/institution',
  LOGIN_SHIBBOLETH: '/shiblogin', // ?providerId&shibbolethToken&grantType
  LOGIN_SELF_MANAGED: '/selfmanralogin', // ?selfmanraToken&grantType'
};

export const routesReducerkey = 'routesReducerkey';

export const sourceKeyMapping = {
  [paths.PREVIEW]: 'main.search.quick.results',
  [paths.SEARCH]: 'main.search.quick.query',
  [paths.ADVANCED]: 'main.search.advancedsearch',
  [paths.RESULTS]: 'main.results.context',
  [paths.HEATMAP]: 'main.results.heatmap',
  [paths.HISTORY_RECENT]: 'main.history.recent',
  [paths.HISTORY_SAVED]: 'main.history.saved',
  [paths.ALERTS]: 'main.alerts',
  [paths.DNS_MAINTENANCE]: 'public.dns-maintenance',
  [paths.REGISTER_BULK]: 'public.register-bulk',
  [paths.REGISTER]: 'public.register',
  [paths.FINALIZE_REGISTER]: 'public.register-finalize',
  [paths.REGISTER_CONFIRMATION]: 'public.register-confirmation',
  [paths.MAINTENANCE]: 'public.maintenance',
  [paths.ERROR]: 'public.error',
  [paths.ABOUT_CONTENT]: 'public.about-content',
  [paths.DEV]: 'main.dev',
  [paths.RS]: 'main.rs',
  [paths.PROFILE]: 'main.profile',
  [paths.PROFILE_ACCOUNT]: 'main.profile.account',
  [paths.PROFILE_PROFILE]: 'main.profile.profile',
  [paths.PROFILE_PREFERENCES]: 'main.profile.preferences',
  [paths.STRUCTURE_EDITOR]: 'main.structure',
  [paths.HOP_INTO]: 'main.hopinto',
  [paths.PRIVATE_REGISTER]: 'private.register',
  [paths.PRIVATE_FINALIZE_REGISTER]: 'private.register-finalize',
  [paths.LOGOUT]: 'public.logout',
  [paths.LOGIN_LIMIT]: 'public.login-limit',
  [paths.LOGIN]: 'public.login',
  [paths.LOGIN_ORGANIZATION]: 'public.organization',
  [paths.LOGIN_INSTITUTION]: 'public.institution',
  [paths.LOGIN_SHIBBOLETH]: 'public.shiblogin',
  [paths.LOGIN_SELF_MANAGED]: 'public.selfmanralogin',
};

export const interactionSubscriptionVars = {
  subscription: false,
  interaction: {},
  cancelBrowserInteraction: null,
};

export const skipLinkMappings = [
  { id: 'header', title: 'Header' },
  { id: 'main-site-navigation', title: 'Navigation' },
  { id: 'main-content', title: 'Main Content' },
  { id: 'footer', title: 'Footer' },
];
